// extracted by mini-css-extract-plugin
module.exports = {"arrowContainer":"ArrowButton_arrowContainer__NEPSE"};